import { Clerk } from "@clerk/clerk-js/no-rhc";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { ConvexQueryClient } from "@convex-dev/react-query";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConvexProviderWithClerk } from "convex/react-clerk";

const CONVEX_URL = import.meta.env.VITE_CONVEX_URL;
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CONVEX_URL) console.error("missing envar VITE_CONVEX_URL");
if (!CLERK_PUBLISHABLE_KEY)
	console.error("missing envar VITE_CLERK_PUBLISHABLE_KEY");

const convexQueryClient = new ConvexQueryClient(CONVEX_URL);
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			queryKeyHashFn: convexQueryClient.hashFn(),
			queryFn: convexQueryClient.queryFn(),
		},
	},
});
convexQueryClient.connect(queryClient);

export default function AppConvexProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<ClerkProvider
			publishableKey={CLERK_PUBLISHABLE_KEY}
			// Use the no-rhc (no React Hook Components) build — zero DOM probing on init,
			// eliminating the 111ms layout reflow from the standard ClerkProvider.
			// biome-ignore lint/suspicious/noExplicitAny: cross-package version cast (clerk-js v6 → clerk-react v5 ClerkProp)
			Clerk={Clerk as any}
		>
			<ConvexProviderWithClerk
				client={convexQueryClient.convexClient}
				useAuth={useAuth}
			>
				<QueryClientProvider client={queryClient}>
					{children}
				</QueryClientProvider>
			</ConvexProviderWithClerk>
		</ClerkProvider>
	);
}
